import { useParams } from 'react-router-dom';

import { fetchServersForControl } from 'api/servers/servers';
import { QueryKeyEnum } from 'core/global.enum';
import { QueryKeyLocalStorageEnum } from 'context/query/queryContext/QueryContext.enum';
import { useQuery } from 'hooks/useQuery/useQuery';
import { useSavedPagination } from 'hooks/useSavedPagination/useSavedPagination';

import { InstantControlTerminals } from './InstantControlTerminals';

export const InstantControlTerminalsContainer = () => {
  const { id: ownerId } = useParams<{ id: string }>();

  const { page, rowsPerPage, setPage, setRowsPerPage, setPaginationCount, paginationCount } = useSavedPagination({
    queryKey: QueryKeyLocalStorageEnum.INSTANT_CONTROL_TERMINALS,
  });

  const { data: serversResponse, isLoading } = useQuery([QueryKeyEnum.INSTANT_CONTROL_TERMINALS, ownerId], () =>
    fetchServersForControl(ownerId),
  );

  return (
    <InstantControlTerminals
      servers={serversResponse?.data}
      isLoading={isLoading}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      terminalsCount={paginationCount}
      setTerminalsCount={setPaginationCount}
    />
  );
};
